/**
 * ResetPasswordModal.jsx
 * Created by michaelbray on 2/14/18.
 * Updated by Destin Frasier on 1/11/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Validator from 'validator';
import axios from 'axios';
import * as Icons from '../../../sharedComponents/icons/Icons';
import * as BrandingIcons from '../../../sharedComponents/icons/branding/BrandingIcons';
import Button from '../../../sharedComponents/Button';
import ResetPasswordForm from './ResetPasswordForm';
import ResetPasswordConfirmation from './ResetPasswordConfirmation';
import { FlexRow, FlexCol } from '../../../sharedComponents/FlexGrid';

const propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    signIn: PropTypes.func
};

const defaultProps = {
    isOpen: false,
    closeModal: () => { },
    signIn: () => { }
};

export default class ResetPasswordModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            emailValidationError: false,
            inputError: false,
            serverError: false,
            completed: false,
            disableResetLinkBtn: false
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.sendResetPasswordEmail = this.sendResetPasswordEmail.bind(this);
        this.confirmEmail = this.confirmEmail.bind(this);
    }

    afterOpenModal() {
        this.setState({
            email: '',
            inputError: false,
            serverError: false,
            completed: false,
            disableResetLinkBtn: false
        });
    }

    emailTextChange(event) {
        this.setState({ email: event.target.value });
    }

    sendResetPasswordEmail() {
        // TODO: Validation
        if (this.state.email.length < 1) {
            this.setState({
                inputError: true,
                serverError: false,
                disableResetLinkBtn: false
            });
        }
        else if (!Validator.isEmail(this.state.email)) {
            this.setState({
                emailValidationError: true,
                disableResetLinkBtn: false
            });
        }
        else {
            this.setState({
                disableResetLinkBtn: true
            }, () => {
                const url = `${process.env.API}/accounts/passwordreset?email=${encodeURIComponent(this.state.email)}`;
                axios.post(url)
                    .then(() => {
                        this.setState({
                            emailValidationError: false,
                            inputError: false,
                            serverError: false,
                            completed: true,
                            disableResetLinkBtn: false
                        });
                    })
                    .catch(() => {
                        this.setState({
                            inputError: false,
                            serverError: true,
                            disableResetLinkBtn: false
                        });
                    });
            });
        }
    }

    confirmEmail(account) {
        this.setState({
            email: account.email
        }, () => {
            this.sendResetPasswordEmail();
        });
    }

    render() {
        let errorText = null;

        if (this.state.inputError) {
            errorText = 'All fields are required.';
        }

        if (this.state.emailValidationError) {
            errorText = 'That is not a valid email address.';
        }

        if (this.state.serverError) {
            errorText = 'An error has occurred, please try again later.';
        }

        let content = null;

        if (this.state.completed) {
            content = (
                <ResetPasswordConfirmation
                    email={this.state.email}
                    sendResetPasswordEmail={this.sendResetPasswordEmail}
                    disableResetLinkBtn={this.state.disableResetLinkBtn} />
            );
        }
        else {
            content = (
                <ResetPasswordForm
                    errorText={errorText}
                    signIn={this.props.signIn}
                    confirmEmail={this.confirmEmail}
                    disableResetLinkBtn={this.state.disableResetLinkBtn} />
            );
        }

        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.props.closeModal}
                className={{
                    base: 'rec-modal-dialog-base',
                    afterOpen: 'rec-modal-dialog-after-open-md rec-acct-modal rec-acct-reset-modal',
                    beforeClose: 'rec-modal-dialog-before-close'
                }}
                overlayClassName={{
                    base: 'rec-overlay-base',
                    afterOpen: 'rec-overlay-after-open',
                    beforeClose: 'rec-overlay-before-close'
                }}
                aria={{
                    labelledby: "resetPasswordModalHeading"
                }}
                ariaHideApp={false}>
                <div className="rec-modal-content-wrap">
                    <FlexRow justifyContent="space-between">
                        <FlexCol className="rec-modal-logo">
                            <BrandingIcons.Logo />
                        </FlexCol>
                        <FlexCol xs="variable">
                            <Button
                                appearance="subtle"
                                iconBeforeElement={<Icons.IconClose />}
                                screenReaderTextBefore="Close Log In as Guest Dialog"
                                onClick={this.props.closeModal}
                                className="rec-close-modal" />
                        </FlexCol>
                    </FlexRow>
                    {content}
                </div>
            </Modal>
        );
    }
}

ResetPasswordModal.propTypes = propTypes;
ResetPasswordModal.defaultProps = defaultProps;
